import React from "react"
import Paper from "material-ui/Paper"
import strings from "../../../localization/strings"
import IconButton from "material-ui/IconButton"
import FontIcon from "material-ui/FontIcon"
import { CircularProgress } from "material-ui"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import { IPayrollExpenses, IPayrollExpensesHierarchy, IPayrollExpensesHierarchyEmployee } from "../../../models"
import FlagCheckred from "../../../../assets/icons/flag-checkered"
import { hasPermission } from "../../../helpers/permissionHelper"
import PayrollExpensesByHierarchyTable from "./PayrollExpensesByHierarchyTable"
import * as payrollHelper from "../../../helpers/payrollHelper"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
    payrollExpensesData: IPayrollExpenses
    loading: boolean
    selectedHierarchies: IPayrollExpensesHierarchy[]
    selectedEmployees: IPayrollExpensesHierarchyEmployee[]
    onDownload(): void
    onDownloadExpensesReport(): void
    onEmployeeLock(): void
    onEmployeeUnLock(): void
    onLock(): void
    onUnLock(): void
    onClose(): void
    onExport(): void
    handleSelectHierarchy(selectedHierarchies: IPayrollExpensesHierarchy[]): void
    handleSelectEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]): void
}

export default class PayrollExpensesByHierarchy extends React.Component<IProps, any> {
    private PayrollExpensesByHierarchyTable = null
    render() {
        const payrollExpensesHierarchies = this.props.payrollExpensesData && this.props.payrollExpensesData.PayrollExpensesHierarchies
        let lockPayrollExpensePermission = hasPermission(AuthenticationStore.Permissions.Expense.LockPayrollExpense)
        let closePayrollExpensePermission = hasPermission(AuthenticationStore.Permissions.Expense.ClosePayrollExpense)
        if (!AuthenticationStore.checkSupervisorAllowPayrollActions()) {
            lockPayrollExpensePermission = false
            closePayrollExpensePermission = false
        }
        const renderElem =
            <div>
                {!this.props.loading &&
                    payrollExpensesHierarchies && payrollExpensesHierarchies.length > 0 &&
                    <div style={{ position: "absolute", right: 40, marginTop: -25 }}>
                        {AccountStore.getEnableEmployeeLock() && lockPayrollExpensePermission &&
                            this.props.selectedHierarchies.filter((item) => !item.EmpLockedData.IsLocked).length > 0 &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-EmployeeLockExpensesPayrollHierarchy"} tooltip={strings.Employee_Lock} onTouchTap={this.props.onEmployeeLock}>
                                <FontIcon className="fa fa-user-lock" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                        {AccountStore.getEnableEmployeeLock() && lockPayrollExpensePermission &&
                            this.props.selectedHierarchies.filter((item) => item.EmpLockedData.IsLocked).length > 0 &&
                            this.props.selectedHierarchies.filter(item => item.ClosedData.IsClosed).length === 0 &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-EmployeeUnLockExpensesPayrollHierarchy"} tooltip={strings.Employee_Unlock} onTouchTap={this.props.onEmployeeUnLock}>
                                <FontIcon className="fa fa-user-unlock" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                        {lockPayrollExpensePermission &&
                            (this.props.selectedHierarchies.filter((item) => !item.LockedData.IsLocked).length > 0 ||
                                (
                                    this.props.selectedHierarchies.length === 0 &&
                                    this.props.selectedEmployees.filter(emp =>
                                        this.props.payrollExpensesData.PayrollExpensesHierarchies.find(hierarchy =>
                                            hierarchy.LockedData.LockedObjData.find(i => i.LockedObjId === emp.EmployeeId))
                                    ).length !== this.props.selectedEmployees.length
                                )
                            ) &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-LockExpensesPayrollHierarchy"} tooltip={strings.Lock} onTouchTap={this.props.onLock}>
                                <FontIcon className="fa fa-lock" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                        {lockPayrollExpensePermission &&
                            (
                                this.props.selectedHierarchies.filter((item) => item.LockedData.IsLocked).length > 0 ||
                                (
                                    this.props.selectedHierarchies.length === 0 &&
                                    this.props.selectedEmployees.filter(emp =>
                                        this.props.payrollExpensesData.PayrollExpensesHierarchies.find(hierarchy =>
                                            hierarchy.LockedData.LockedObjData.find(i => i.LockedObjId === emp.EmployeeId))
                                    ).length > 0
                                )
                            ) &&
                            this.props.selectedHierarchies.filter(item => item.ClosedData.IsClosed).length === 0 &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-UnLockExpensesPayrollHierarchy"} tooltip={strings.Unlock} onTouchTap={this.props.onUnLock}>
                                <FontIcon className="fa fa-unlock" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                        {AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
                            closePayrollExpensePermission &&
                            this.props.selectedHierarchies.length > 0 &&
                            this.props.selectedHierarchies.filter(item => !item.ClosedData.IsClosed).length > 0 &&
                            <IconButton
                                tooltip={strings.Close}
                                onTouchTap={() => payrollHelper.getValidClosePayroll(this.props.payrollExpensesData.PayrollDates.EndDate, this.props.payrollExpensesData.PayGroupPaySettings) ?
                                    this.props.onClose() :
                                    AppStateStore.setProgressSnackbarContent(strings.Cannot_close_current_or_future_period)
                                }
                            >
                                <FlagCheckred color="rgb(97, 97, 97)" width={20} height={20} />
                            </IconButton>
                        }
                        <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollFile"} tooltip={strings.Download_Payroll_Expenses_File} onTouchTap={this.props.onDownload}>
                            <FontIcon className="fa fa-download" style={{ fontSize: 20 }} />
                        </IconButton>
                        <IconButton data-intercom-target={"menu-Payroll-Btn-DownloadPayrollExpensesReport"} tooltip={strings.Download_Expenses_Report} onTouchTap={this.props.onDownloadExpensesReport}>
                            <FontIcon className="fa fa-file-text" style={{ fontSize: 20 }} />
                        </IconButton>
                        {hasPermission(AuthenticationStore.Permissions.Expense.ExportPayrollExpense) &&
                            <IconButton data-intercom-target={"menu-Payroll-Btn-ExportPayrollExpense"} tooltip={strings.ExportPayrollFile} onTouchTap={this.props.onExport}>
                                <FontIcon className="fa fa-arrow-circle-right" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                    </div>
                }
                {this.props.loading ?
                    <div style={{ textAlign: "center", marginTop: 30 }}>
                        <CircularProgress />
                    </div> :
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                        {payrollExpensesHierarchies && payrollExpensesHierarchies.length > 0 ?
                            <PayrollExpensesByHierarchyTable
                                ref={(elem) => this.PayrollExpensesByHierarchyTable = elem}
                                payrollExpensesHierarchies={payrollExpensesHierarchies}
                                handleSelectHierarchy={this.props.handleSelectHierarchy}
                                handleSelectEmployee={this.props.handleSelectEmployee}
                            /> :
                            <div style={{ fontSize: 20, marginTop: 50 }}>{strings.No_Payroll_Expenses_by_Hierarchy_Data}</div>
                        }
                    </div>
                }
            </div>

        return hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) ?
            <Paper zDepth={1} style={{ marginTop: 15, paddingTop: 10, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, position: "relative" }}>
                <div style={{ fontSize: 16, fontWeight: 600, position: "absolute", top: 15 }}>{strings.Expenses_Summary}</div>
                {renderElem}
            </Paper> :
            renderElem
    }
}
